export const detailedLFV1 = ["OriginalAsIsLtv", "OriginalLtcLtp"];

export const detailedPropPLFV1 = [
  "ESRIPopulationDensity",
  "ZillowCBSA",
  "AdjustedAsIsValue",
];
